import {
  GET_ABOUT_US,
  UPDATE_ABOUT_US,
  GET_ABOUT_US_REQUEST_PENDING,
  GET_ABOUT_US_REQUEST_SUCCESS,
  GET_ABOUT_US_REQUEST_ERROR,
  CHANGE_ABOUT_US_REQUEST_PENDING,
  CHANGE_ABOUT_US_REQUEST_SUCCESS,
  CHANGE_ABOUT_US_REQUEST_ERROR,
} from '../types/aboutUs'

const initialState = {
  item: null,
  isGetLoading: false,
  isChangeLoading: false,
  errors: [],
}

const aboutUs = (state = initialState, action) => {
  switch (action.type) {
    case GET_ABOUT_US:
      return { ...state, item: action.payload || null }

    case UPDATE_ABOUT_US:
      return { ...state, item: action.payload || null }

    case GET_ABOUT_US_REQUEST_PENDING:
      return { ...state, isGetLoading: true }

    case GET_ABOUT_US_REQUEST_SUCCESS:
      return { ...state, errors: [], isGetLoading: false }

    case GET_ABOUT_US_REQUEST_ERROR:
      return { ...state, errors: action.payload, isGetLoading: false }

    case CHANGE_ABOUT_US_REQUEST_PENDING:
      return { ...state, isChangeLoading: true }

    case CHANGE_ABOUT_US_REQUEST_SUCCESS:
      return { ...state, errors: [], isChangeLoading: false }

    case CHANGE_ABOUT_US_REQUEST_ERROR:
      return { ...state, errors: action.payload, isChangeLoading: false }

    default:
      return state
  }
}

export default aboutUs

